import moment from "moment";
import * as constant from "./constant";
import { getPeriod } from "../../../src/utils/period";
const arrPeriod = ["1D", "1M", "3M", "6M", "1Y"]

export const mutations = {
    [constant.INDICE_LIST](state, payload) {
        if (payload) {
            state.indiceList = payload;
        }
    },
    [constant.INDICE_RANKING](state, { payload, period }) {
        if (payload) {
            let return_period = getPeriod(period.toUpperCase());
            state.indiceRanking = [];
            state.indiceRankingReturn = [];
            payload.forEach(item => {
                state.indiceRanking.push({
                    id: item.security_id,
                    name: item.symbol,
                    data_date: item.update_dt,
                    period: period,
                    percent: item[return_period],
                    price: item.close || 0,
                    sector_no: item.sector_no,
                    industry_no: item.industry_no
                });
                state.indiceRankingReturn.push({
                    id: item.security_id,
                    return_1d: item.return_1d,
                    return_1m: item.return_1m,
                    return_6m: item.return_6m,
                    return_1y: item.return_1y,
                    return_3y: item.return_3y,
                    return_5y: item.return_5y
                });
            });
        }
    },
    [constant.INDICE_PRICE](state, period) {
        if (period) {
            let return_period = getPeriod(period.toUpperCase());
            state.indiceRanking.map(item => (item.period = period));
            state.indiceRankingReturn.forEach(item => {
                state.indiceRanking.filter(i => i.id == item.id).map(i => (i.percent = item[return_period]));
            });
        }
    },
    [constant.INDICE_FOLLOWING](state, payload) {
        if (payload) {
            state.indiceFollowing = payload;
        }
    },
    [constant.INDICE_QUOTE](state, payload) {
        if (payload) {
            state.indiceQuote = payload;
        }
    },
    [constant.INDICE_NAV](state, payload) {
        let arr = [];
        let v;
        if (payload && payload.c) {
            for (let i = 0; i < payload.c.length; i++) {
                v = payload.c[i];
                let nav_date = moment.unix(payload.t[i]).format("YYYY-MM-DD");
                let d = moment.unix(parseInt(payload.t[i])).utc()._d;
                arr = [
                    ...arr,
                    {
                        amount: payload.v[i],
                        v,
                        nav_date,
                        value: v,
                        d
                    }
                ];
            }
            state.indiceNav = arr
        } else {
            payload = []
        }
    },
    [constant.INDICE_NAV_SHARE](state, payload) {
        if (payload && payload.length > 0) {
            for (let i = 0; i < payload.length; i++) {
                let diffValue = "";
                let diffPercent = "";

                if (payload[i].c && payload[i].c.length > 0) {
                    let data = payload[i].c;

                    let firstObj = data[0];
                    let lastObj = data[data.length - 1];
                    let firstVal = parseFloat(firstObj);
                    let lastVal = parseFloat(lastObj);
                    let diffVal = lastVal - firstVal;

                    // find close price diff
                    let diffValToFixed = diffVal.toFixed(4);
                    let parts = diffValToFixed.toString().split(".");
                    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                    diffValue = parts.join(".");

                    // find percent close price diff
                    let diffValPercent = (diffVal / firstVal) * 100;
                    diffPercent = diffValPercent.toFixed(2);
                }
                state.indiceNavShare[arrPeriod[i]] = {
                    value: diffValue,
                    percent: diffPercent
                }
            }
        }
    },
    [constant.INDICE_TIMESTAMP_1D](state, payload) {
        if (payload) {
            state.indiceTimestamp1D = payload;
        }
    }
}
